import "./Solutions.module.css";
import Header from "@/reusable_sections/Header";
import GuestApplication from "./sections/GuestApplication";
import Technicalfleetdashboard from "./sections/Technicalfleetdashboard";
import AdminPanel from "./sections/AdminPanel";
import RequestADemo from "./sections/RequestADemo";
import Footer from "@/reusable_sections/Footer";
export default function SolutionsPage() {
  return <div>
      <Header />
      <GuestApplication />
      <Technicalfleetdashboard />
      <AdminPanel />
      <RequestADemo />
      <Footer />
    </div>;
}